<template>
  <div class="delete-account-form">
    <h3 class="delete-account-form__headline">
      {{ $t("headline") }}
    </h3>
    <p class="delete-account-form__text">
      {{ text }}
    </p>
    <notification v-if="errorCopy" class="delete-account-form__error" type="error">
      {{ errorCopy }}
    </notification>
    <form class="delete-account-form__form form" @submit="submit">
      <div v-if="hasPassword" class="delete-account-form__field">
        <label class="delete-account-form__label form__label" for="delete-account-form-password">
          {{ $t("label") }}
        </label>
        <div class="form__field">
          <show-password
            :allow-shorter-old-passwords="true"
            name="password"
            id="delete-account-form-password"
            v-model="password"
          />
        </div>
      </div>
      <div class="delete-account-form__footer">
        <button class="delete-account-form__cancel" type="button" @click="close">
          {{ $t("cancel") }}
        </button>
        <button class="delete-account-form__submit button" :disabled="loading">
          {{ $t("save") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import ShowPassword from "@/shared/show-password"
import Notification from "@/shared/notification"

export default {
  name: "DeleteAccountForm",
  components: {
    ShowPassword,
    Notification
  },
  data() {
    return {
      password: null
    }
  },
  computed: {
    ...mapGetters("settings", {
      error: "errorDeleteAccount"
    }),
    ...mapState({
      loading: (state) => state.settings.deleteAccount.loading,
      hasPassword: (state) => state.settings.deleteAccount.hasPassword
    }),
    errorCopy() {
      if (!this.error) {
        return
      }
      let key = "default"
      if (this.$te(`error.${this.error}`)) {
        key = this.error
      }
      return this.$t(`error.${key}`)
    },
    text() {
      return this.hasPassword ? this.$t("text") : this.$t("socialsText")
    }
  },
  methods: {
    submit(e) {
      e.preventDefault()
      e.stopPropagation()
      this.$store.dispatch("settings/deleteAccount", this.password)
    },
    close() {
      this.$store.dispatch("settings/closeDeleteAccount")
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Delete your account",
        text: "Confirm your password to delete your account. This action can not be undone.",
        socialsText: "Please confirm deleting your account below. This action can not be undone.",
        label: "Password",
        cancel: "Cancel",
        save: "Delete",
        error: {
          default: "An error occured",
          /* eslint-disable-next-line camelcase */
          wrong_password: "Your password is wrong."
        }
      },
      de: {
        headline: "Account löschen",
        text: "Um deinen Account unwiderruflich zu löschen, gib dein Passwort ein und bestätige.",
        socialsText: "Bestätige hiermit, dass du deinen Account unwiderruflich löschen möchtest.",
        label: "Passwort",
        cancel: "Abbrechen",
        save: "Löschen"
      },
      error: {
        default: "Ein Fehler ist aufgetreten",
        /* eslint-disable-next-line camelcase */
        wrong_password: "Falsches Passwort"
      }
    }
  }
}
</script>

<style lang="scss">
.delete-account-form {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: $x-wide-block-width;
  padding: $spacing-48 $spacing-24 $spacing-24;

  &__headline {
    @include font-style(h3);

    width: 100vw;
    max-width: 100%;
    margin-bottom: $spacing-24;
  }

  &__text {
    @include font-style(p);

    margin-bottom: $spacing-24;
  }

  &__error {
    margin-bottom: $spacing-24;
  }

  &__field {
    margin-bottom: $spacing-24;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }

  &__cancel {
    @include font-style(button, $color: $mid-grey);

    margin-right: $spacing-16;

    cursor: pointer;
  }

  @include media(max-width, s) {
    $padding: map-get($container-paddings, xs);

    padding-right: $padding;
    padding-left: $padding;
  }
}
</style>
